<div>

    <div class="feld-beschreibung-table-toolbar">
        <mat-form-field redispatchProvideReadonly>
            <mat-label>Filter</mat-label>
            <input matInput data-qa="filter" (keyup)="applyFilter($event)" #input>
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
        </mat-form-field>
    </div>

    <table [dataSource]="feldBeschreibungList"
           mat-table
           matSort
           class="feld-beschreibung-table"
           data-qa="data-table">

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr style="cursor: pointer" mat-row *matRowDef="let feld; columns: columnsToDisplay"
            (click)="openFeldBeschreibung(feld)"></tr>

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
            <td mat-cell *matCellDef="let feld;">{{feld.title}}</td>
        </ng-container>

        <ng-container matColumnDef="hilfetext">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hilfetext</th>
            <td mat-cell *matCellDef="let feld;">{{feld.hilfetext}}</td>
        </ng-container>

    </table>
</div>
